import { apiRequest } from "../utils/useAPIRequest";
import constant from "../utils/constant";
import { supportStore } from "../stores";
import { useQuery } from "@tanstack/react-query";
import { useMemo } from "react";
import { queryClient } from "../App";

const useGetNews = (newsTableQuery, filterQuery, searchQuery) => {
  const query = useMemo(() => {
    if (searchQuery && filterQuery) {
      return `${newsTableQuery}&${filterQuery}&search=${searchQuery}`;
    } else if (searchQuery) {
      return `${newsTableQuery}&search=${searchQuery}`;
    } else if (filterQuery) {
      return `${newsTableQuery}&${filterQuery}`;
    } else {
      return newsTableQuery;
    }
  }, [filterQuery, newsTableQuery, searchQuery]);

  return useQuery({
    queryKey: ["getNews", query],
    queryFn: () => {
      return apiRequest({
        url: `/news?${query}`,
        method: "get",
      });
    },
    keepPreviousData: true,
  });
};

const createNews = async (payload) => {
  const { status, errorMessage, data } = await apiRequest({
    url: "/news/news",
    method: "post",
    payload,
  });
  if (status === constant.Success) {
    queryClient.invalidateQueries({
      queryKey: ["getNews"],
    });
    return { status: constant.Success, data };
  }
  return { errorMessage, status, data };
};

const updateNews = async (payload, id) => {
  const { status, errorMessage, data } = await apiRequest({
    url: `/news/news/${id}`,
    method: "patch",
    payload,
  });
  if (status === constant.Success) {
    queryClient.invalidateQueries({
      queryKey: ["getNews"],
    });
    return { status: constant.Success, data };
  }
  return { errorMessage, status, data };
};

const deleteNews = async (id) => {
  const { status, errorMessage } = await apiRequest({
    url: `/news/news/${id}`,
    method: "delete",
  });
  if (status === constant.Success) {
    queryClient.invalidateQueries({ queryKey: ["getNews"] });
    return { status };
  }
  return { status, errorMessage };
};

export default {
  useGetNews,
  createNews,
  updateNews,
  deleteNews,
};
